import { Orb, type OrbProps } from "./Orb";
import { clsx } from "clsx";

export function OrbDisc({
  mode = "voice",
  orbSize = "default",
  ringClassName,
  ...orbProps
}: OrbProps & {
  mode?: "voice" | "text";
  orbSize?: "default" | "small";
  ringClassName?: string;
}) {
  const isSmall = orbSize === "small";

  return (
    <div className='tw-absolute tw-inset-0 tw-z-20 tw-pointer-events-none'>
      <div
        className={clsx(
          "tw-relative tw-mx-auto tw-max-w-full tw-aspect-square tw-transition tw-duration-[400ms] tw-ease-in-out tw-origin-top tw-w-64",
          mode === "text" && "sm:tw-rotate-90",
        )}
      >
        <div
          className={clsx(
            "tw-absolute tw-inset-0 tw-transition tw-duration-[400ms] tw-ease-in-out tw-rounded-full tw-overflow-hidden tw-origin-top sm:tw-origin-center",

            mode === "text" && [
              isSmall ? "tw-scale-[0.2]" : "tw-scale-[0.15625]",
              "sm:-tw-rotate-90 sm:tw-translate-x-5 sm:-tw-translate-y-1",
            ],
          )}
        >
          <div
            className={clsx(
              "tw-absolute tw-aspect-square tw-rounded-full tw-overflow-hidden",
              isSmall
                ? "tw-w-[12.5rem] tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"
                : "tw-top-0 tw-left-0 tw-w-full",
            )}
          >
            <Orb {...orbProps} />
            <div className='tw-absolute tw-inset-0 tw-rounded-full tw-ring-0.5 tw-ring-inset tw-ring-black/7.5' />
            {ringClassName && <div className={clsx("tw-absolute tw-inset-0 tw-rounded-full", ringClassName)} />}
          </div>
        </div>
      </div>
    </div>
  );
}
